"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _dropdownMenu = require("@design/ui/dropdown-menu");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function formatDate(dateString) {
  if (!dateString) return "Unknown date";
  var date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "Unknown date";
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
}
function ApplyAllButton(_ref) {
  var isReportDone = _ref.isReportDone,
    hasIssues = _ref.hasIssues,
    allIssuesFinished = _ref.allIssuesFinished,
    isBulkApplying = _ref.isBulkApplying,
    hasBulkApplied = _ref.hasBulkApplied,
    onBulkApply = _ref.onBulkApply,
    hasReviews = _ref.hasReviews;
  if (!hasReviews) return null;
  if (!isReportDone) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    size: "lg",
    disabled: true,
    children: "Running..."
  });
  if (isBulkApplying) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    size: "lg",
    disabled: true,
    children: "Applying..."
  });
  if (hasBulkApplied) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    size: "lg",
    disabled: true,
    children: "Applied"
  });
  if (!hasIssues) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    size: "lg",
    disabled: true,
    children: "Apply all"
  });
  if (allIssuesFinished) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    size: "lg",
    onClick: onBulkApply,
    children: "Apply all"
  });
  return null;
}
function IssueListHeader(_ref2) {
  var _currentReview$playbo;
  var reviews = _ref2.reviews,
    currentReviewId = _ref2.currentReviewId,
    onReviewSelect = _ref2.onReviewSelect,
    _ref2$fallbackTitle = _ref2.fallbackTitle,
    fallbackTitle = _ref2$fallbackTitle === void 0 ? "" : _ref2$fallbackTitle,
    isReportDone = _ref2.isReportDone,
    hasIssues = _ref2.hasIssues,
    allIssuesFinished = _ref2.allIssuesFinished,
    onBulkApply = _ref2.onBulkApply,
    _ref2$isBulkApplying = _ref2.isBulkApplying,
    isBulkApplying = _ref2$isBulkApplying === void 0 ? false : _ref2$isBulkApplying,
    _ref2$hasBulkApplied = _ref2.hasBulkApplied,
    hasBulkApplied = _ref2$hasBulkApplied === void 0 ? false : _ref2$hasBulkApplied,
    _ref2$showSearch = _ref2.showSearch,
    showSearch = _ref2$showSearch === void 0 ? false : _ref2$showSearch,
    _ref2$isSearchExpande = _ref2.isSearchExpanded,
    isSearchExpanded = _ref2$isSearchExpande === void 0 ? false : _ref2$isSearchExpande,
    onSearchToggle = _ref2.onSearchToggle,
    onBack = _ref2.onBack,
    descriptionSlot = _ref2.descriptionSlot,
    _ref2$showDescription = _ref2.showDescription,
    showDescription = _ref2$showDescription === void 0 ? false : _ref2$showDescription,
    _ref2$isCollapsed = _ref2.isCollapsed,
    isCollapsed = _ref2$isCollapsed === void 0 ? false : _ref2$isCollapsed;
  var currentReview = currentReviewId ? reviews === null || reviews === void 0 ? void 0 : reviews.find(function (r) {
    return r.id === currentReviewId;
  }) : undefined;
  var currentTitle = (_currentReview$playbo = currentReview === null || currentReview === void 0 ? void 0 : currentReview.playbooks.map(function (p) {
    return p.name;
  }).join(", ")) !== null && _currentReview$playbo !== void 0 ? _currentReview$playbo : fallbackTitle;
  var showDropdown = !!reviews && reviews.length > 1 && !!onReviewSelect;
  var sortedReviews = _toConsumableArray(reviews || []).sort(function (a, b) {
    var dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    var dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return dateB - dateA;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "h-10 flex items-center gap-4 justify-between w-full min-w-0 box-border mb-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-4 flex-1 min-w-0 overflow-hidden focus-ring-room",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "button",
          variant: "ghost",
          size: "icon-sm",
          "aria-label": "Back",
          onClick: onBack,
          "data-sentry-element": "Button",
          "data-sentry-source-file": "IssueListHeader.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
            "data-sentry-element": "ArrowBackIcon",
            "data-sentry-source-file": "IssueListHeader.tsx"
          })
        }), showDropdown ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenu, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuTrigger, {
            asChild: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
              variant: "ghost",
              className: "shrink min-w-0 max-w-75 text-label-sm uppercase tracking-wide text-foreground-muted",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "truncate",
                children: currentTitle || "Select Review"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
                "data-icon": "inline-end",
                className: "transition-transform group-data-[state=open]/button:rotate-180"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuContent, {
            className: "min-w-50",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuRadioGroup, {
              value: currentReviewId !== null && currentReviewId !== void 0 ? currentReviewId : undefined,
              onValueChange: onReviewSelect,
              children: sortedReviews.map(function (r) {
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuRadioItem, {
                  value: r.id,
                  className: "flex-col items-start gap-1",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: "w-full truncate font-medium",
                    children: r.playbooks.map(function (p) {
                      return p.name;
                    }).join(", ")
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                    className: "text-xs text-muted-foreground",
                    children: [r.createdAt ? formatDate(r.createdAt) : "Unknown", r.author && " by ".concat(r.author)]
                  })]
                }, r.id);
              })
            })
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "flex-1 truncate text-label-sm uppercase tracking-wide text-foreground-muted",
          children: currentTitle
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-4 flex-shrink-0",
        children: [showSearch && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "button",
          variant: "ghost",
          size: "icon-xs",
          onClick: onSearchToggle,
          "aria-label": "Search",
          className: (0, _utils.cn)(isSearchExpanded && "invisible"),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SearchIcon, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyAllButton, {
          isReportDone: isReportDone,
          hasIssues: hasIssues,
          allIssuesFinished: allIssuesFinished,
          isBulkApplying: isBulkApplying,
          hasBulkApplied: hasBulkApplied,
          onBulkApply: onBulkApply,
          hasReviews: !!reviews && reviews.length > 0,
          "data-sentry-element": "ApplyAllButton",
          "data-sentry-source-file": "IssueListHeader.tsx"
        })]
      })]
    }), showDescription && !isCollapsed && descriptionSlot]
  });
}
var _default = exports.default = IssueListHeader;